import React from 'react';
import { TranslatedBadge } from './translated_badge';

function BestsellerBadge({ color }) {
    return (
        <TranslatedBadge type="bestseller" translationKey="badge-bestseller" color={color} />
    );
}

export { BestsellerBadge };
